import { Link2 } from 'lucide-react'

function SectionHeader({ title, desc }: { title: string; desc?: string }) {
  return (
    <div className="mb-1">
      <h3 className="text-xs font-medium tracking-tight text-foreground">{title}</h3>
      {desc ? <p className="text-xs text-muted-foreground">{desc}</p> : null}
    </div>
  )
}

export function NewsPanel() {
  return (
    <div className="space-y-3">
      <SectionHeader title="Sources" desc="Connect feeds or paste a headline URL." />
      <div className="rounded-lg border border-border bg-card p-3 text-xs text-muted-foreground">
        <div className="flex items-center gap-2 text-foreground">
          <Link2 size={14} />
          <span>Add a source</span>
        </div>
        <p className="mt-1">No articles yet.</p>
      </div>
    </div>
  )
}
